module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-man-50_76fe0dff76cf068ca2bab4ea1cda15c7.jpg";